export default __webpack_public_path__ + "static/media/logo-activa.59629fa2.png";